module.exports = __webpack_public_path__ + "img/16.00d7024a.svg";